export default __webpack_public_path__ + "static/media/sevensis.b8b08ce1.jpg";